module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/financial-unit-lvl3-100.16de3605.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/financial-unit-lvl3-100.png
// module id = 3531
// module chunks = 11